<template>
  <div class="contact-box">
    <template v-if="hasDefaultSlot">
      <slot></slot>
    </template>
    <template v-else>
      <CardHeader class="-faq">よくあるご質問・お問い合わせ</CardHeader>
      <CardBody>
        <ElementBox class="-center">
          <p>au PAY スマートローンに関するよくあるご質問はこちら</p>
          <BtnMain
            class="-normal"
            href="https://qa.kddi-fs.com/?site_domain=loan"
            target="_blank"
            >よくあるご質問</BtnMain
          >
        </ElementBox>
        <ElementBox class="-center">
          <p>au PAY スマートローンに関するお問い合わせはこちら</p>
          <BtnMain
            v-if="member"
            class="-normal"
            router-name="sv036"
            target="_blank"
            >お問い合わせ</BtnMain
          >
          <BtnMain v-else class="-normal" router-name="sv036"
            >お問い合わせ</BtnMain
          >
        </ElementBox>
      </CardBody>
    </template>
  </div>
</template>

<script>
import CardBody from "@/components/card/CardBody";
import ElementBox from "@/components/elements/ElementBox";
import BtnMain from "@/components/button/BtnMain";
import CardHeader from "@/components/card/CardHeader";

export default {
  name: "ContactBox",
  components: {
    CardHeader,
    BtnMain,
    ElementBox,
    CardBody,
  },
  props: {
    member: { type: Boolean, default: false },
  },
  computed: {
    hasDefaultSlot() {
      return !!this.$slots.default;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.contact-box {
  border: 1px solid #cccccc;
  border-radius: 10px;
  @include mq-down(md) {
    margin: 0 -20px;
    border: none;
    border-radius: 0px;
  }
  > .card-header {
    background: $primary;
    text-align: center;
    color: $white;
    font-weight: normal;
    @include mq-down(md) {
      border-radius: 0px;
      font-size: 18px;
    }
    @include mq-up(md) {
      font-size: 24px;
    }
    & + .card-body {
      padding-top: 20px;
      @include mq-up() {
        padding-top: 30px;
      }
    }
  }
}
</style>
